import React from 'react'
import { useNavigate } from 'react-router-dom'
import useUser from 'commons/hooks/useUser'
import { ADMIN, ADMIN_MASTER, PRODUCTOR, PRODUCTOR_MUSICAL, PRODUCTOR_CAST, MANAGER } from 'commons/constants/profiles'
import Button from 'components/Button'
import Typography from 'components/Typography'
import { CentralizedContainer, LogoIcon } from './styles'

function Forbidden() {
  const navigate = useNavigate()

  const { hasProfile } = useUser()

  const onBackToHomeClick = () => navigate('/')

  return (
    <CentralizedContainer>
      <LogoIcon />
      <Typography variant="h2" margin={{ top: 4, bottom: 4 }}>
        Acesso Negado
      </Typography>
      <Typography fontSize={20} color="gray" margin={{ bottom: 1 }}>
        Você não possui acesso a esta página.
      </Typography>
      <Typography fontSize={20} color="gray">
        Por favor, procure um administrador.
      </Typography>
      {(hasProfile(PRODUCTOR_MUSICAL || ADMIN) ||
        hasProfile(ADMIN_MASTER || PRODUCTOR) ||
        hasProfile(MANAGER || PRODUCTOR_CAST)) && (
        <Button uppercased={false} id="back" margin={{ top: 8 }} onClick={onBackToHomeClick} size="large">
          Voltar para Página Inicial
        </Button>
      )}
    </CentralizedContainer>
  )
}

export default Forbidden
